webpackJsonp([263791100135453],{

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BannerLanding = __webpack_require__(5);
	
	var _BannerLanding2 = _interopRequireDefault(_BannerLanding);
	
	var _BannerSection = __webpack_require__(6);
	
	var _BannerSection2 = _interopRequireDefault(_BannerSection);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About(props) {
	  var _props$data$contentfu = props.data.contentfulAbout,
	      title = _props$data$contentfu.title,
	      metaDescription = _props$data$contentfu.metaDescription,
	      headerBackgroundImage = _props$data$contentfu.headerBackgroundImage,
	      sectionFourHeading = _props$data$contentfu.sectionFourHeading,
	      sectionFourContent = _props$data$contentfu.sectionFourContent;
	
	
	  return _react2.default.createElement(
	    'div',
	    { id: 'main', className: 'alt-colors' },
	    _react2.default.createElement(_BannerLanding2.default, {
	      title: title,
	      desc: metaDescription,
	      bg: headerBackgroundImage !== null ? headerBackgroundImage.file.url : undefined
	    }),
	    _react2.default.createElement(
	      'section',
	      { id: 'section-four' },
	      _react2.default.createElement(
	        'div',
	        { className: 'inner' },
	        _react2.default.createElement(
	          'header',
	          null,
	          _react2.default.createElement(_BannerSection2.default, { sectionContent: sectionFourHeading })
	        ),
	        sectionFourContent !== null ? _react2.default.createElement('div', {
	          dangerouslySetInnerHTML: {
	            __html: sectionFourContent.childMarkdownRemark.html
	          }
	        }) : undefined
	      )
	    ),
	    _react2.default.createElement('hr', null)
	  );
	}; // eslint-disable-line import/no-extraneous-dependencies
	// import YouTube from 'react-youtube'
	
	
	About.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = {
	  blogPostDir: 'blog', // The name of directory that contains your posts.
	  siteTitle: 'Killasser Parish Church', // Site title.
	  siteTitleAlt: 'Killasser Parish Church', // Alternative site title for SEO.
	  // siteLogo: '/assets/images/logos/ironcove-large-logo.png', // Logo used for SEO and manifest.
	  siteUrl: 'https://killasser-parish.netlify.com/about', // Domain of your website without pathPrefix.
	  pathPrefix: '/', // Prefixes all links. For cases when deployed to example.github.io/gatsby-material-starter/.
	  // googleTagManagerId: 'GTM-89N8',
	  fixedFooter: false, // Whether the footer component is fixed, i.e. always visible
	  siteDescription: 'The online community for the Parish of Killasser. Here you will find interesting facts, photos and forthcoming events about your community.', // Website description used for RSS feeds/meta description tag.
	  siteRss: '/rss.xml', // Path to the RSS file.
	  // siteFBAppID: '629904053861902', // FB Application ID for using app insights
	  // siteGATrackingID: 'UA-20307710-3', // Tracking code ID for google analytics.
	  // disqusShortname: 'https-vagr9k-github-io-gatsby-material-starter', // Disqus shortname.
	  // postDefaultCategoryID: 'Tech', // Default category for posts.
	  // userName: 'Material User', // Username to display in the author segment.
	  // userTwitter: 'sandeep8851', // Optionally renders "Follow Me" in the UserInfo segment.
	  userLocation: 'Killasser, Mayo Ireland', // User location to display in the author segment.
	  // userAvatar: 'https://api.adorable.io/avatars/150/test.png', // User avatar to display in the author segment.
	  userDescription: 'The online community for the Parish of Killasser. Here you will find interesting facts, photos and forthcoming events about your community.', // User description to display in the author segment.
	  // Links to social profiles/projects you want to display in the author segment/navigation bar.
	  // userLinks: [
	  //   {
	  //     label: 'LinkedIn',
	  //     url: 'https://www.linkedin.com/company/iron-cove-solutions/',
	  //     iconClassName: 'fa fa-linkedin',
	  //   },
	  //   {
	  //     label: 'Google+',
	  //     url: 'https://plus.google.com/+Ironcovesolutions',
	  //     iconClassName: 'fa fa-google-plus',
	  //   },
	  //   {
	  //     label: 'Tumblr',
	  //     url: 'http://ironcovesolutions.tumblr.com/',
	  //     iconClassName: 'fa fa-tumblr',
	  //   },
	  //   {
	  //     label: 'Youtube',
	  //     url: 'https://www.youtube.com/user/ironcovesolutions',
	  //     iconClassName: 'fa fa-youtube',
	  //   },
	  //   {
	  //     label: 'Facebook',
	  //     url: 'https://www.facebook.com/IronCoveSolutions',
	  //     iconClassName: 'fa fa-facebook',
	  //   },
	  //   {
	  //     label: 'Twitter',
	  //     url: 'https://twitter.com/Ironcove',
	  //     iconClassName: 'fa fa-twitter',
	  //   },
	  //   {
	  //     label: 'Email',
	  //     url: 'sales@ironcovesolutions.com',
	  //     iconClassName: 'fa fa-envelope',
	  //   },
	  // ],
	  copyright: 'Copyright © 2018. Killasser Church Parish' // Copyright string for the footer of the website and RSS feed.
	};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.aboutQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(4);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _SiteConfig = __webpack_require__(15);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _About = __webpack_require__(142);
	
	var _About2 = _interopRequireDefault(_About);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// config
	// eslint-disable-line import/no-extraneous-dependencies
	var AboutPage = function AboutPage(props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        'title',
	        null,
	        'About | ' + props.data.site.siteMetadata.title
	      ),
	      _react2.default.createElement('meta', {
	        name: 'description',
	        content: props.data.contentfulAbout.metaDescription
	      })
	    ),
	    _react2.default.createElement(_About2.default, { data: props.data })
	  );
	};
	
	// components
	// eslint-disable-line import/no-extraneous-dependencies
	
	
	AboutPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = AboutPage;
	var aboutQuery = exports.aboutQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-ac98accd1578573fd93b.js